import { Permissions } from "shared/model/AllPermissions";
import { defaultEnvironmentName } from "../../shared/model/AgentGroup";
import { HashMap } from "../../shared/model/HashMap";
import { ThunkResult, Utilities } from "../../shared/utilities";
import { fetchAgentgroupsAction } from "../actions/FetchAgentGroups";
import { fetchEditorReadOnly, fetchItems, intercomDocumentationEnabled, receiveApiSpecs, receiveEnvironmentVariables, receiveSubProcesses, receiveTasks, receiveTimeZones, receiveUserSnippets, tcpTriggerEnabled } from "../actions/FetchDataItems";
import { IAction } from "../model/IAction";
import { IElement, IElementDictionary } from "../model/IProcessData";
import { migrateElementData } from "../model/Migrations/index";
import { State } from "../model/State";
import { SNIPPETS_ENDPOINT } from "./SnippetActions";

export function fetchData(isNewProcess: boolean) {
    return (dispatch: any) => {
        // ACC-7723: If Frends.ApiManagement.View permission is denied, user should still be able to open a Process.
        const hasAPIManagementViewPermission = Utilities.getUserPermission(Permissions.ApiManagementView);
        return Promise.all([
            dispatch(fetchItems("api/process/task", receiveTasks)),
            dispatch(fetchItems("api/environmentVariable/keys", receiveEnvironmentVariables)),
            dispatch(fetchAgentgroupsAction(isNewProcess)),
            dispatch(fetchItems("api/process/timezones", receiveTimeZones)),
            dispatch(fetchItems("api/process/subprocesses", receiveSubProcesses)),
            dispatch(fetchItems(SNIPPETS_ENDPOINT, receiveUserSnippets)),
            dispatch(fetchIntercomDocumentationConfigured("api/documentation")),
            dispatch(fetchEditorReadOnly(!Utilities.getUserPermission(Permissions.ProcessEdit))),
            hasAPIManagementViewPermission ? dispatch(fetchItems(`api/apiSpec/${defaultEnvironmentName}/simple`, receiveApiSpecs)) : null,
            dispatch(fetchFeatureFlags())
        ]);
    };
}


export function fetchIntercomDocumentationConfigured(fetchUri: string): ThunkResult<Promise<IAction | void>, State> {
    return async (dispatch) => {
        try {
            const response = await Utilities.getFetch<boolean>(fetchUri);
            if (response) {
                return dispatch(intercomDocumentationEnabled())
            }
        } catch (e) {
            console.error(e);
            Utilities.toastError(e);
        }
    };
}

export function fetchFeatureFlags(): ThunkResult<Promise<IAction | void>, State> {
    return async (dispatch) => {
        try {
            const response = await Utilities.fetchFeatureFlags();
            if (response.tcpTrigger) {
                return dispatch(tcpTriggerEnabled())
            }
        } catch (e) {
            console.error(e);
            Utilities.toastError(e);
        }
    };
}

export const RECEIVE_ALL = "RECEIVE_ALL";
export function receiveAll(elements: IElement[]): ThunkResult<IAction, State> {
    return (dispatch) => {

        const migratedInitialElements: HashMap<IElement> = {};
        elements.forEach((element) => {
            migratedInitialElements[element.id] = migrateElementData(element);
        });

        dispatch({
            type: SET_INITIAL_ELEMENTS,
            initialElements: migratedInitialElements
        });

        return dispatch({
            type: RECEIVE_ALL,
        });
    };
}

export const SET_INITIAL_ELEMENTS = "SET_INITIAL_ELEMENTS";

export interface InitialElements extends IAction {
    initialElements: IElementDictionary;
}
